/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/promql/x-pack-esql/definition/functions/histogram_count.json`.

import type { PromqlFunctionDefinition } from '../../definition_types';

/**
 * Returns the count of observations stored in a native histogram.
 *
 * @example
 * histogram_count(increase(http_request_duration_seconds[5m]))
 */
const definition: PromqlFunctionDefinition = {
  type: 'histogram',
  name: 'histogram_count',
  signatures: [
    {
      params: [
        {
          name: 'v',
          type: 'instant_vector',
          optional: false,
          description: 'Instant vector input.',
        },
      ],
      variadic: false,
      returnType: 'instant_vector',
    },
  ],
  snapshotOnly: false,
};

export default definition;
